

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('error', (error) => {
        console.error('Caught Error Message:', error.message)
    })
})
